import { createFilterOptions } from "@material-ui/lab";
import React from "react";

import color from "../../constants/color";
import materialUI from "../../material-UI";
import { AutoCompleteCustom, Text, Helper, Label, Container } from "./styls";

interface Props {
  onChange: any;
  data: Array<any>;
  label: string;
  limitResult?: number;
  value: any;
  isError?: boolean;
  helperText?: string;
  placeholder?: string;
  isMultitple?: boolean;
  marginRightProps?: number;
  disabled?: boolean;
  borderRadius?: string | undefined;
  width?: string;
}

const useStyles = materialUI.makeStyles({
  root: {
    "& fieldset": {
      borderWith: "1px",
      borderColor: "#D0D5DD",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#2D5BFF !important",
    },
    "& input::placeholder": {
      textOverflow: "ellipsis !important",
    },
    "&:hover fieldset": {
      borderColor: "#2D5BFF !important",
    },
  },
});

const AutoComplete: React.FC<Props> = ({
  onChange,
  data,
  label,
  limitResult,
  value,
  isMultitple,
  isError,
  helperText,
  placeholder,
  marginRightProps,
  borderRadius,
  disabled,
  width,
}) => {
  const filterOptions = createFilterOptions({
    limit: limitResult,
  });
  return (
    <Container>
      {label ? (
        <Label color={isError ? "red" : color.black}>{label}</Label>
      ) : null}
      <AutoCompleteCustom
        borderRadius={borderRadius!}
        filterOptions={filterOptions}
        classes={{ root: useStyles().root }}
        options={data}
        value={value}
        size="small"
        style={{
          color: isError === true ? "red" : "#D0D5DD",
          backgroundColor: disabled ? "#D0D5DD" : "#ffffff",
          marginRight: marginRightProps,
          width,
        }}
        autoComplete={false}
        disabled={disabled}
        clearOnBlur
        getOptionLabel={(option: any) => option.label || ""}
        getOptionSelected={(option: any) => option.label || ""}
        onChange={(event: any, newValue) => {
          onChange(newValue);
        }}
        multiple={isMultitple}
        renderInput={(params) => (
          <Text
            {...params}
            placeholder={placeholder || ""}
            classes={{ root: useStyles().root }}
            error={isError}
            variant="outlined"
          />
        )}
      />
      {isError && helperText && <Helper>{helperText}</Helper>}
    </Container>
  );
};
export default AutoComplete;
